import React from "react";
import SPQSFormGroup from "./SPQSFormGroup";
import useSPQS from "../../hooks/useSPQS";
import useSPQSUndo from "../../hooks/useSPQSUndo";
import "./QSSP.css";
import { ignoreEnter, addEdits, handleProductSelect, handleInputSelect } from "./utils/inputhandlers";
import SearchField from "../SearchField/SearchField";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { decimToPercent } from "./utils/transformators";
import useLoadSPpositions from "./hooks/useLoadSPpositions";
const QSSPGeneral = ({
  clearfield,
  setClearfield,
  navpostoedit,
  setNavpostoedit,
  showUSposList,
  setShowUSposList,
  setReloadPoslistdata,
  reloadPoslistdata,
}) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  // Load Contexts
  const { SPQS, setSPQS, setSPQSData, qstoedit, setPpaymenttermSPQS, setPpaymenttermDataSPQS, whdataSP, setWhdataSP } =
    useSPQS();
  const { SPQSEdits, editIDSPQS, setEditIDSPQS, undoListSPQS, inputRefsSPQS, setEditingFieldSPQS } = useSPQSUndo();
  // Hooks
  const spposlist = useLoadSPpositions("loadactivesppositions", reloadPoslistdata);

  // navigate to positionsUSA and send navpostoedit to load it
  const handleNavToSPPos = () => {
    navigate("/positions/spain", { state: { positiontoedit: navpostoedit } });
  };

  // load Position into QS
  const loadPositionToQSSP = async (item) => {
    setNavpostoedit(item.SPposID);
    const currency = ["materialcost"];
    const dates = ["shipfrom", "shipuntil"];
    const quantities = ["materialcost"];
    const addedvals = ["WGP", "product", "supplier", "bagSize", "bagMarkType"];
    const addeddata = ["WGP", "productID", "supplierID", "bagSizeID", "bagMarkTypeID"];
    const keepvals = [...currency, ...dates, ...addedvals];
    const keepdata = [...dates, ...quantities, ...addeddata];
    try {
      const response = await axiosPrivate.post("/api/qs/loadPosToQSSP", {
        WGP: item.WGP,
      });
      const addvals = Object.fromEntries(
        Object.entries(response.data[0])
          .filter(([key]) => keepvals.includes(key))
          .map(([key, value]) => {
            if (currency.includes(key)) {
              return [key, `$${parseFloat(value).toFixed(2)}`];
            } else if (dates.includes(key)) {
              return [key, moment(value).format("YYYY-MM-DD")];
            } else if (quantities.includes(key)) {
              return [key, Number(value)];
            } else {
              return [key, value];
            }
          })
      );
      const adddata = Object.fromEntries(
        Object.entries(response.data[0])
          .filter(([key]) => keepdata.includes(key))
          .map(([key, value]) => {
            if (dates.includes(key)) {
              return [key, moment(value).format("YYYY-MM-DD")];
            } else if (quantities.includes(key)) {
              return [key, Number(value)];
            } else {
              return [key, value];
            }
          })
      );
      setClearfield(!clearfield);
      setSPQS((prev) => ({ ...prev, ...addvals }));
      setSPQSData((prev) => ({ ...prev, ...adddata }));
      SPQSEdits.current.push(
        {
          editID: editIDSPQS,
          name: "WGP",
          value: addvals.WGP,
          num: adddata.WGP,
          figuretype: "integer",
        },
        {
          editID: editIDSPQS,
          nameID: "productID",
          valueID: adddata.productID,
          name: "product",
          value: addvals.product,
        },
        {
          editID: editIDSPQS,
          nameID: "supplierID",
          valueID: adddata.supplierID,
          name: "supplier",
          value: addvals.supplier,
        },
        {
          editID: editIDSPQS,
          nameID: "bagSizeID",
          valueID: adddata.bagSizeID,
          name: "bagSize",
          value: addvals.bagSize,
        },
        {
          editID: editIDSPQS,
          nameID: "bagMarkTypeID",
          valueID: adddata.bagMarkTypeID,
          name: "bagMarkType",
          value: addvals.bagMarkType,
        },
        {
          editID: editIDSPQS,
          name: "shipfrom",
          value: addvals.shipfrom,
          num: adddata.shipfrom,
          figuretype: "text",
        },
        {
          editID: editIDSPQS,
          name: "shipuntil",
          value: addvals.shipuntil,
          num: adddata.shipuntil,
          figuretype: "text",
        },
        {
          editID: editIDSPQS,
          name: "materialcost",
          value: addvals.materialcost,
          num: adddata.materialcost,
          figuretype: "currency",
        },
        {
          editID: editIDSPQS,
          num: item.SPposID,
          figuretype: "posloadedtoqs",
        }
      );
    } catch (err) {
      console.error(err);
    }
    try {
      const response1 = await axiosPrivate.post("/api/qs/loadPosPaytermsToQSSP", {
        positionID: item.SPposID,
      });
      let ppterm = response1.data.map(({ portion, payType, termdays }) => ({
        portion: decimToPercent(portion),
        payType,
        termdays,
      }));
      let pptermdata = response1.data.map(({ portion, payTypeID, termdays }) => ({
        portion,
        payTypeID,
        termdays,
      }));
      setPpaymenttermSPQS(ppterm);
      setPpaymenttermDataSPQS(pptermdata);
      SPQSEdits.current.push({
        editID: editIDSPQS,
        data: pptermdata,
        vals: ppterm,
        figuretype: "ptermsfrompos",
      });
    } catch (err) {
      console.error(err);
    }
    try {
      const response2 = await axiosPrivate.post("/api/qs/loadWHtoQSSP", {
        positionID: item.SPposID,
      });
      setWhdataSP(response2.data[0]);
      setSPQS((prev) => ({ ...prev, ["whexit"]: moment().format("YYYY-MM-DD") }));
      setSPQSData((prev) => ({ ...prev, ["whexit"]: moment().format("YYYY-MM-DD") }));
    } catch (err) {
      console.error(err);
    }
    setEditIDSPQS((prev) => prev + 1);
    setShowUSposList(false);
  };

  return (
    <>
      <SPQSFormGroup readOnly={true} labelname={"QSID"} inputname={"SPQSID"} />
      <SPQSFormGroup readOnly={true} type={"date"} labelname={"QS Date"} inputname={"QSDate"} />
      <fieldset style={{ overflow: "visible" }}>
        <legend>Quote From:</legend>
        <div className='purchasefrom form-group'>
          <label>
            <input
              name='qstype'
              type='radio'
              checked={SPQS && SPQS.qstype === 1 ? true : false}
              onClick={(e) => {
                setSPQS((prev) => ({ ...prev, ["qstype"]: 1 }));
                setSPQSData((prev) => ({ ...prev, ["qstype"]: 1 }));
                SPQSEdits.current.push({
                  editID: editIDSPQS,
                  name: e.target.name,
                  value: 1,
                  num: 1,
                  figuretype: "radio",
                });
                setEditIDSPQS((prev) => prev + 1);
                setEditingFieldSPQS(false);
                undoListSPQS.current = [];
              }}
              value={SPQS.qstype}
              required
            />
            Back-to-back
          </label>
        </div>
        <div
          className='purchasefrom form-group'
          style={{ display: "flex", flexDirection: "row", position: "relative", overflow: "visible" }}
        >
          <label>
            <input
              name='qstype'
              type='radio'
              checked={SPQS && SPQS.qstype === 2 ? true : false}
              onClick={(e) => {
                setSPQS((prev) => ({ ...prev, ["qstype"]: 2, ["pincoterm"]: "EXW" }));
                setSPQSData((prev) => ({ ...prev, ["qstype"]: 2, ["pincotermID"]: 1 }));
                SPQSEdits.current.push(
                  {
                    editID: editIDSPQS,
                    name: e.target.name,
                    value: 2,
                    num: 2,
                    figuretype: "radio",
                  },
                  {
                    editID: editIDSPQS,
                    nameID: "pincotermID",
                    name: "pincoterm",
                    value: "EXW",
                    valueID: 1,
                  }
                );
                setEditIDSPQS((prev) => prev + 1);
                setEditingFieldSPQS(false);
                undoListSPQS.current = [];
              }}
              value={SPQS.qstype}
              required
            />
            Spain Position
          </label>
          <div style={{ position: "relative", overflow: "visible" }}>
            {SPQS.qstype === 2 && (
              <button type='button' onClick={() => setShowUSposList(true)}>
                Select Position
              </button>
            )}
            {showUSposList && (
              <ListWithFilters
                data={spposlist}
                columns={["SPposID", "WGP", "product", "supplier", "quantity", "sold", "inventory"]}
                mainclass='SPQS-lwf-pos'
                rowID='WGP'
                onRowClick={loadPositionToQSSP}
                placeHolders={true}
                placeHolderList={["SPposID", "WGP", "Product", "Supplier", "Quantity", "Sold", "Inventory"]}
                size={["S", "S", "M", "M", "S", "S", "S"]}
                setReloadlistdata={setReloadPoslistdata}
              />
            )}
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Identifiers:</legend>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <SPQSFormGroup
            readOnly={SPQS.qstype === 2}
            labelname={"WGP"}
            inputname={"WGP"}
            inputtype={"integer"}
            cplaceholder={"WGP..."}
            required={false}
          />
          {SPQS.qstype === 2 && SPQS.WGP && (
            <button type='button' onClick={() => handleNavToSPPos()} style={{ margin: 0, height: "25px" }}>
              Go
            </button>
          )}
        </div>
        <SPQSFormGroup
          labelname={"WGSUS"}
          inputname={"WGS"}
          inputtype={"integer"}
          cplaceholder={"WGSUS..."}
          required={false}
        />
      </fieldset>
      <fieldset>
        <legend>General:</legend>
        <div className='form-group'>
          <label>Product:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/qs/getprodsupplier'
            value={SPQS?.product || ""}
            valueName='product'
            secondaryValueName='supplier'
            valueID='productID'
            style={{ width: "90%" }}
            customplaceholder='Select Product'
            onItemSelect={(item) => {
              handleProductSelect(
                item,
                setSPQS,
                setSPQSData,
                SPQSEdits,
                addEdits,
                editIDSPQS,
                setEditIDSPQS,
                undoListSPQS
              );
            }}
            clearfield={clearfield}
          />
        </div>
        <div className='form-group'>
          <label>Supplier:</label>
          <input
            readOnly
            placeholder='Supplier...'
            onKeyDown={ignoreEnter}
            name={"supplierID"}
            value={SPQS?.supplier || ""}
          />
        </div>
        <div className='form-group'>
          <label>Customer:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/qs/getcustomers'
            value={SPQS?.customer || ""}
            valueName='customer'
            valueID='customerID'
            style={{ width: "90%" }}
            customplaceholder='Select Customer'
            onItemSelect={(item) => {
              handleInputSelect(
                item,
                SPQSEdits,
                editIDSPQS,
                setEditIDSPQS,
                setSPQS,
                setSPQSData,
                addEdits,
                undoListSPQS,
                "customer",
                "customer"
              );
            }}
            clearfield={clearfield}
          />
        </div>
      </fieldset>
    </>
  );
};

export default QSSPGeneral;
